import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation, Trans } from '@mc/i18n'
import { CheckoutEvents } from '@mc/pre-paywall-events'
import { track, Locations } from '@mc/track-event'
import FacebookButton from '../FacebookButton'
import GoogleButton from '../GoogleButton'
import FormFields from './FormFields'

const GiftRegisterForm = (props) => {
  const { onLoginClick, facebookSignUp, userAgent } = props

  const { t } = useTranslation('@mc/authentication')

  useEffect(() => {
    track(CheckoutEvents.EVENTS.CART_EMAIL_VIEWED, {
      location: Locations.ACTIVATION_PAYMENT_LOCATION,
    })
  }, [])

  return (
    <div>
      <h4 className='mc-text-h4 mc-text--center mc-mb-6'>{t('giftTitle')}</h4>
      <p className='mc-text--center mc-mb-6 mc-opacity--muted'>
        {t('giftSubtitle')}
      </p>
      <div className='mc-mb-4'>
        <GoogleButton userAgent={userAgent}>{t('google')}</GoogleButton>
      </div>

      <div className='mc-mb-4'>
        <FacebookButton onLogin={facebookSignUp} userAgent={userAgent}>
          {t('facebook')}
        </FacebookButton>
      </div>

      <div className='mc-mb-4'>
        <p className='mc-text-hr mc-text-x-small mc-opacity--muted mc-text--uppercase mc-mt-3'>
          <span>{t('or')}</span>
        </p>
      </div>

      <FormFields {...props} />

      <Trans i18nKey='alreadyMember' ns='@mc/authentication'>
        <p className='mc-text--center mc-mt-4'>
          <span className='mc-text--bold' />
          <a className='mc-text--link' onClick={onLoginClick}></a>
        </p>
      </Trans>
    </div>
  )
}

GiftRegisterForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  facebookSignUp: PropTypes.func.isRequired,
  onLoginClick: PropTypes.func.isRequired,
  userAgent: PropTypes.string,
}

export default GiftRegisterForm
